import React from 'react';
import { useEffect, useState } from 'react';
import './accordion.scss';
import Channels from './Channel';

const Accordion = (props) => {
  delete props.canaisDoPlano.planName
  const categoriaAberta = props.categoriaAberta;
  const changeOpenedCategorie = props.changeOpenedCategorie;
  const canaisDoPlano = props.canaisDoPlano;

  const [existeHD, setExisteHD] = useState([]);

  const filtroHd = props.filtroHd;

  useEffect(() => {
    separeteHD();
  }, [filtroHd]);

  const separeteHD = () => {
    setExisteHD([]);
    const chanels = Object.keys(canaisDoPlano);

    const HDChanels = [];

    chanels.map((item) => {
      const dataChanels = canaisDoPlano[item];

      const withHD = dataChanels.filter((item) => (filtroHd ? item.nome?.toLowerCase().includes('hd') : item));

      HDChanels[item] = withHD;
    });

    setExisteHD(HDChanels);
  };

  return (
    <div className="mdn-Accordion">
      {/*  {filtroHd.toString()} */}
      {Object.keys(canaisDoPlano).map((key) => {
        return (
          existeHD[key]?.length > 0 && (
            <div key={key} className={`mdn-Accordion-box ${categoriaAberta === key ? `is-expanded` : ``}`}>
              <button
                className="mdn-Accordion-toggle mdn-Text mdn-Text--body mdn-u-color--danger"
                onClick={() => changeOpenedCategorie(key)}
              >
                <div>
                  {key}
                  <br />
                </div>
                <i className="mdn-Accordion-icon mdn-Icon-baixo mdn-Icon--lg" />
              </button>
              {categoriaAberta === key && <Channels canais={existeHD[key]} filtroHd={filtroHd} />}
            </div>
          )
        );
      })}
    </div>
  );
};

export default Accordion;
